
import { Options, Vue } from 'vue-class-component'
import Milkfarm from '@/components/screens/Milkfarm.vue'
import StartMenu from "@/components/screens/StartMenu.vue"
import HelpMenu from "@/components/screens/HelpMenu.vue"
import SaveSystem from "@/SaveSystem"
import globalState from "@/store/globalState"
import PatchNotesScreen from "@/components/screens/PatchNotesScreen.vue"
import CreditsScreen from "@/components/screens/CreditsScreen.vue"

@Options({
  components: {
    Milkfarm, StartMenu, HelpMenu, PatchNotesScreen, CreditsScreen
  },
  methods: {
    log(msg: any) {
      console.log(msg)
    },
  },
  computed: {
    cssVars() {
      return {
        '--background-image': 'url(' + require('@/assets/frances-gunn-blurred-12.webp') + ')'
      }
    }
  },
  async created() {
    await globalState().load()
    this.saveSystem = new SaveSystem()
    //let farm = new Farm()
    //this.farm = farm
    this.isLoaded = true
  }
})
export default class App extends Vue {
  isLoaded = false
  activeComponent: string = 'StartMenu'
  saveSystem!: SaveSystem
}
